export const SET_ALERT = 'SET_ALERT';
export const REMOVE_ALERT = 'REMOVE_ALERT';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';
export const LOGOUT = 'LOGOUT';
export const USER_LOADED = 'USER_LOADED';
export const AUTH_ERROR = 'AUTH_ERROR';
export const GET_ALL_VENDING_MACHINES = 'GET_ALL_VENDING_MACHINES';
export const GET_VENDING_MACHINE = 'GET_VENDING_MACHINE';
export const GET_VENDING_MACHINE_STOCK = 'GET_VENDING_MACHINE_STOCK';
export const ADD_VENDING_MACHINE = 'ADD_VENDING_MACHINE';
export const UPDATE_VENDING_MACHINE = 'UPDATE_VENDING_MACHINE';
export const DELETE_VENDING_MACHINE = 'DELETE_VENDING_MACHINE';
export const ADD_PRODUCT = 'ADD_PRODUCT';
export const GET_PRODUCT = 'GET_PRODUCT';
export const GET_ALL_PRODUCTS = 'GET_ALL_PRODUCTS';
export const GET_PRODUCT_REQUEST ='GET_PRODUCT_REQUEST';
export const DELETE_PRODUCT = 'DELETE_PRODUCT';
export const OPEN_CONTAINER='OPEN_CONTAINER';
export const GET_ALL_ORDERS = 'GET_ALL_ORDERS';
export const GET_ALL_ORDER_REQUEST = 'GET_ALL_ORDER_REQUEST';
export const GET_ORDER_REQUEST = 'GET_ORDER_REQUEST';
export const ORDER_LOADING = 'ORDER_LOADING';
export const CLEAR_ORDER = 'CLEAR_ORDER';
export const GET_ALL_USER_REQUEST = 'GET_ALL_USER_REQUEST';
export const GET_ALL_USERS_SUCCESS = 'GET_ALL_USERS';
export const GET_USER_REQUEST = 'GET_USER_REQUEST';
export const GET_USER_SUCCESS = 'GET_USER_SUCCESS';
export const ADD_USER_REQUEST = 'ADD_USER_REQUEST';
export const ADD_USER_SUCCESS = 'ADD_USER_SUCCESS';
export const UPDATE_USER_REQUEST = 'UPDATE_USER_REQUEST';
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';
export const GET_USER_BY_QUERY = 'GET_USER_BY_QUERY';
export const GET_CONTAINERS = 'GET_CONTAINERS';
export const GET_REGIONS = 'GET_REGIONS';
export const GET_PROFILE_REQUEST = 'GET_PROFILE_REQUEST';
export const GET_PROFILE = 'GET_PROFILE';
export const GET_PROFILES = 'GET_PROFILES';
export const CREATE_PROFILE = 'CREATE_PROFILE';
export const UPDATE_PROFILE = 'UPDATE_PROFILE';
export const CLEAR_PROFILE = 'CLEAR_PROFILE';
export const DELETE_PROFILE = 'DELETE_PROFILE';
export const CLEAR_NEW_PROFILE_CREATED = 'CLEAR_NEW_PROFILE_CREATED';

export const GET_REGION = 'GET_REGION';
export const GET_REGION_REQUEST = 'GET_REGION_REQUEST';
export const UPDATE_REGION = 'UPDATE_REGION';
export const ADD_CONTAINERS = 'ADD_CONTAINERS';
export const GET_TRANSACTIONS_REQUEST = 'GET_TRANSACTIONS_REQUEST';
export const GET_ALL_TRANSACTIONS = 'GET_ALL_TRANSACTIONS';
export const UPDATE_TRANSACTIONS = 'UPDATE_TRANSACTIONS';
export const REFUND_CAN = 'REFUND_CAN';
export const UPDATE_USER_CANS = 'UPDATE_USER_CANS';
export const ADD_STOCK = 'ADD_STOCK';
export const REMOVE_STOCK = 'REMOVE_STOCK';
export const GET_ORDERS_DOWNLOAD = 'GET_ORDERS_DOWNLOAD';
export const GET_TRANSACTIONS_DOWNLOAD = 'GET_TRANSACTIONS_DOWNLOAD';
export const VENDING_MACHINE_LOADING = 'VENDING_MACHINE_LOADING';
export const GET_INVENTORY_STATUS = 'GET_INVENTORY_STATUS';
export const GET_CAN_STOCK = 'GET_CAN_STOCK';
export const UPDATE_CONTAINER = 'UPDATE_CONTAINER';
export const CHECK_PAYMENT = 'CHECK_PAYMENT';
export const GET_LEDGER = 'GET_LEDGER';
export const VENDING_MACHINE_REGISTRATION = 'VENDING_MACHINE_REGISTRATION';
export const LIST_REGISTERED_VENDING_MACHINE = 'LIST_REGISTERED_VENDING_MACHINE';
export const REGISTERED_VENDING_MACHINE = 'REGISTERED_VENDING_MACHINE';
export const AVAILABLE_VENDING_MACHINE = 'AVAILABLE_VENDING_MACHINE';
export const GET_TRANSACTION_LEDGER = 'GET_TRANSACTION_LEDGER';
// export const GET_REPORT = 'GET_REPORT';
// export const DOWNLOAD_PING_REPORT = 'DOWNLOAD_PING_REPORT';
export const LIST_REGISTERED_VENDING_MACHINE_PRODUCT = 'LIST_REGISTERED_VENDING_MACHINE_PRODUCT';
export const SESSION_ID_FOR_TESTING = 'SESSION_ID_FOR_TESTING';
export const PING_DATA_DOWNLOAD = "PING_DATA_DOWNLOAD";
export const LOCK_DATA_DOWNLOAD = "LOCK_DATA_DOWNLOAD";
export const SESSION_RESULTS = "SESSION_RESULTS";
export const GET_SALES = "GET_SALES";
export const DOWNLOAD_SALES = "DOWNLOAD_SALES";
export const GET_ACCOUNT_DELETION_REQUEST = "GET_ACCOUNT_DELETION_REQUEST";
export const GET_PACKAGES = "GET_PACKAGES"
export const GET_PACKAGE = "GET_PACKAGE"
export const GET_PACKAGES_MEMBERSHIPS = "GET_PACKAGES_MEMBERSHIPS"
export const CREATE_PACKAGE = "CREATE_PACKAGE"
export const UPDATE_PACKAGE = "UPDATE_PACKAGE"
export const DELETE_PACKAGE = "DELETE_PACKAGE"
export const GET_ALL_NOTES_SUCCESS = "GET_ALL_NOTES_SUCCESS"
export const CREATE_NOTE = "CREATE_NOTE"
export const UPDATE_NOTE = "UPDATE_NOTE"
export const DELETE_NOTE = "DELETE_NOTE"
export const GET_DEPOSIT_LEDGER_ALL = "GET_DEPOSIT_LEDGER_ALL"
export const GET_DEPOSIT_LEDGER_USER = "GET_DEPOSIT_LEDGER_USER"
export const DEPOSIT_LEDGER_LOADING = "DEPOSIT_LEDGER_LOADING"
export const GET_MEMBERSHIPS = "GET_MEMBERSHIPS"
export const GET_MEMBERSHIP = "GET_MEMBERSHIP"
export const CREATE_MEMBERSHIP = "CREATE_MEMBERSHIP"
export const UPDATE_MEMBERSHIP = "UPDATE_MEMBERSHIP"
export const DELETE_MEMBERSHIP = "DELETE_MEMBERSHIP"

// Accessory types
export const GET_ACCESSORY = "GET_ACCESSORY"
export const GET_ALL_ACCESSORIES = "GET_ALL_ACCESSORIES"
export const GET_ACCESSORY_REQUEST = "GET_ACCESSORY_REQUEST"
export const CREATE_ACCESSORY = "CREATE_ACCESSORY"
export const UPDATE_ACCESSORY = "UPDATE_ACCESSORY"
export const DELETE_ACCESSORY = "DELETE_ACCESSORY"
export const CLEAR_ACCESSORY = "CLEAR_ACCESSORY"

// Accessory Purchase types
export const GET_ACCESSORY_PURCHASE = "GET_ACCESSORY_PURCHASE"
export const GET_ALL_ACCESSORY_PURCHASES = "GET_ALL_ACCESSORY_PURCHASES"
export const GET_ACCESSORY_PURCHASE_REQUEST = "GET_ACCESSORY_PURCHASE_REQUEST"
export const CREATE_ACCESSORY_PURCHASE = "CREATE_ACCESSORY_PURCHASE"
export const UPDATE_ACCESSORY_PURCHASE = "UPDATE_ACCESSORY_PURCHASE"
export const DELETE_ACCESSORY_PURCHASE = "DELETE_ACCESSORY_PURCHASE"
export const CLEAR_ACCESSORY_PURCHASE = "CLEAR_ACCESSORY_PURCHASE"

// Unserviceable Area Request types
export const GET_UNSERVICEABLE_AREA_REQUEST = "GET_UNSERVICEABLE_AREA_REQUEST"
export const GET_ALL_UNSERVICEABLE_AREA_REQUESTS = "GET_ALL_UNSERVICEABLE_AREA_REQUESTS"
export const GET_UNSERVICEABLE_AREA_REQUEST_REQUEST = "GET_UNSERVICEABLE_AREA_REQUEST_REQUEST"
export const DELETE_UNSERVICEABLE_AREA_REQUEST = "DELETE_UNSERVICEABLE_AREA_REQUEST"
export const CLEAR_UNSERVICEABLE_AREA_REQUEST = "CLEAR_UNSERVICEABLE_AREA_REQUEST"

export const GET_GETSTARTED = 'GET_GETSTARTED';
export const GET_GETSTARTEDS = 'GET_GETSTARTEDS';
export const GETSTARTED_ERROR = 'GETSTARTED_ERROR';
export const DELETE_GETSTARTED = 'DELETE_GETSTARTED';
export const ADD_GETSTARTED = 'ADD_GETSTARTED';
export const UPDATE_GETSTARTED = 'UPDATE_GETSTARTED';

// Referral Content types
export const GET_REFERRAL_CONTENT = "GET_REFERRAL_CONTENT";
export const GET_ALL_REFERRAL_CONTENTS = "GET_ALL_REFERRAL_CONTENTS";
export const GET_REFERRAL_CONTENT_REQUEST = "GET_REFERRAL_CONTENT_REQUEST";
export const CREATE_REFERRAL_CONTENT = "CREATE_REFERRAL_CONTENT";
export const UPDATE_REFERRAL_CONTENT = "UPDATE_REFERRAL_CONTENT";
export const DELETE_REFERRAL_CONTENT = "DELETE_REFERRAL_CONTENT";
export const CLEAR_REFERRAL_CONTENT = "CLEAR_REFERRAL_CONTENT";

// Delivery Management types
export const GET_DELIVERY_MANAGEMENT = "GET_DELIVERY_MANAGEMENT";
export const DELIVERY_LOADING = "DELIVERY_LOADING";
export const ASSIGN_DELIVERY_AGENT = "ASSIGN_DELIVERY_AGENT";
export const UPDATE_DELIVERY_STATUS = "UPDATE_DELIVERY_STATUS";
export const DELIVERY_ERROR = "DELIVERY_ERROR";
export const GET_DELIVERY_AGENTS = "GET_DELIVERY_AGENTS";

// Delivery Can Transaction types
export const GET_DELIVERY_CAN_TRANSACTIONS = "GET_DELIVERY_CAN_TRANSACTIONS";
export const GET_DELIVERY_CAN_TRANSACTION = "GET_DELIVERY_CAN_TRANSACTION";
export const DELIVERY_CAN_TRANSACTION_LOADING = "DELIVERY_CAN_TRANSACTION_LOADING";
export const DELIVERY_CAN_TRANSACTION_ERROR = "DELIVERY_CAN_TRANSACTION_ERROR";
export const UPDATE_DELIVERY_CAN_TRANSACTION = "UPDATE_DELIVERY_CAN_TRANSACTION";
export const CLEAR_DELIVERY_CAN_TRANSACTIONS = "CLEAR_DELIVERY_CAN_TRANSACTIONS";

// Can Return types
export const GET_CAN_RETURNS = "GET_CAN_RETURNS";
export const CAN_RETURN_LOADING = "CAN_RETURN_LOADING";
export const CAN_RETURN_ERROR = "CAN_RETURN_ERROR";
export const UPDATE_CAN_RETURN = "UPDATE_CAN_RETURN";

// Agent types
export const GET_AGENT = "GET_AGENT";
export const GET_ALL_AGENTS = "GET_ALL_AGENTS";
export const GET_AGENT_REQUEST = "GET_AGENT_REQUEST";
export const CREATE_AGENT = "CREATE_AGENT";
export const UPDATE_AGENT = "UPDATE_AGENT";
export const DELETE_AGENT = "DELETE_AGENT";
export const CLEAR_AGENT = "CLEAR_AGENT";
export const AGENT_ERROR = "AGENT_ERROR";
export const AGENT_LOADING = "AGENT_LOADING";

// ServiceableArea types
export const GET_SERVICEABLE_AREA = "GET_SERVICEABLE_AREA";
export const GET_ALL_SERVICEABLE_AREAS = "GET_ALL_SERVICEABLE_AREAS";
export const GET_SERVICEABLE_AREA_REQUEST = "GET_SERVICEABLE_AREA_REQUEST";
export const CREATE_SERVICEABLE_AREA = "CREATE_SERVICEABLE_AREA";
export const UPDATE_SERVICEABLE_AREA = "UPDATE_SERVICEABLE_AREA";
export const DELETE_SERVICEABLE_AREA = "DELETE_SERVICEABLE_AREA";
export const CLEAR_SERVICEABLE_AREA = "CLEAR_SERVICEABLE_AREA";
export const SERVICEABLE_AREA_ERROR = "SERVICEABLE_AREA_ERROR";
export const SERVICEABLE_AREA_LOADING = "SERVICEABLE_AREA_LOADING";

// SuperServiceableArea types
export const GET_SUPER_SERVICEABLE_AREA = "GET_SUPER_SERVICEABLE_AREA";
export const GET_ALL_SUPER_SERVICEABLE_AREAS = "GET_ALL_SUPER_SERVICEABLE_AREAS";
export const GET_SUPER_SERVICEABLE_AREA_REQUEST = "GET_SUPER_SERVICEABLE_AREA_REQUEST";
export const CREATE_SUPER_SERVICEABLE_AREA = "CREATE_SUPER_SERVICEABLE_AREA";
export const UPDATE_SUPER_SERVICEABLE_AREA = "UPDATE_SUPER_SERVICEABLE_AREA";
export const DELETE_SUPER_SERVICEABLE_AREA = "DELETE_SUPER_SERVICEABLE_AREA";
export const CLEAR_SUPER_SERVICEABLE_AREA = "CLEAR_SUPER_SERVICEABLE_AREA";
export const SUPER_SERVICEABLE_AREA_ERROR = "SUPER_SERVICEABLE_AREA_ERROR";
export const SUPER_SERVICEABLE_AREA_LOADING = "SUPER_SERVICEABLE_AREA_LOADING";

// Sector types
export const GET_SECTOR = "GET_SECTOR";
export const GET_ALL_SECTORS = "GET_ALL_SECTORS";
export const GET_SECTOR_REQUEST = "GET_SECTOR_REQUEST";
export const CREATE_SECTOR = "CREATE_SECTOR";
export const UPDATE_SECTOR = "UPDATE_SECTOR";
export const DELETE_SECTOR = "DELETE_SECTOR";
export const CLEAR_SECTOR = "CLEAR_SECTOR";
export const SECTOR_ERROR = "SECTOR_ERROR";
export const SECTOR_LOADING = "SECTOR_LOADING";

// InventoryNode types
export const GET_INVENTORY_NODE = "GET_INVENTORY_NODE";
export const GET_ALL_INVENTORY_NODES = "GET_ALL_INVENTORY_NODES";
export const GET_INVENTORY_NODE_REQUEST = "GET_INVENTORY_NODE_REQUEST";
export const CREATE_INVENTORY_NODE = "CREATE_INVENTORY_NODE";
export const UPDATE_INVENTORY_NODE = "UPDATE_INVENTORY_NODE";
export const DELETE_INVENTORY_NODE = "DELETE_INVENTORY_NODE";
export const CLEAR_INVENTORY_NODE = "CLEAR_INVENTORY_NODE";
export const INVENTORY_NODE_ERROR = "INVENTORY_NODE_ERROR";
export const INVENTORY_NODE_LOADING = "INVENTORY_NODE_LOADING";

// AgentSectorAssignment types
export const GET_AGENT_ASSIGNMENT = "GET_AGENT_ASSIGNMENT";
export const GET_ALL_AGENT_ASSIGNMENTS = "GET_ALL_AGENT_ASSIGNMENTS";
export const GET_AGENT_ASSIGNMENT_REQUEST = "GET_AGENT_ASSIGNMENT_REQUEST";
export const CREATE_AGENT_ASSIGNMENT = "CREATE_AGENT_ASSIGNMENT";
export const UPDATE_AGENT_ASSIGNMENT = "UPDATE_AGENT_ASSIGNMENT";
export const DELETE_AGENT_ASSIGNMENT = "DELETE_AGENT_ASSIGNMENT";
export const CLEAR_AGENT_ASSIGNMENT = "CLEAR_AGENT_ASSIGNMENT";
export const AGENT_ASSIGNMENT_ERROR = "AGENT_ASSIGNMENT_ERROR";
export const AGENT_ASSIGNMENT_LOADING = "AGENT_ASSIGNMENT_LOADING";

// Notification types
export const GET_NOTIFICATION = "GET_NOTIFICATION";
export const GET_NOTIFICATIONS = "GET_NOTIFICATIONS";
export const NOTIFICATION_ERROR = "NOTIFICATION_ERROR";
export const DELETE_NOTIFICATION = "DELETE_NOTIFICATION";
export const ADD_NOTIFICATION = "ADD_NOTIFICATION";
export const UPDATE_NOTIFICATION = "UPDATE_NOTIFICATION";

// FAQ types
export const GET_FAQ = "GET_FAQ";
export const GET_FAQS = "GET_FAQS";
export const FAQ_ERROR = "FAQ_ERROR";
export const DELETE_FAQ = "DELETE_FAQ";
export const ADD_FAQ = "ADD_FAQ";
export const UPDATE_FAQ = "UPDATE_FAQ";

// Water Quality types
export const GET_ACTIVE_WATER_QUALITY = "GET_ACTIVE_WATER_QUALITY";
export const GET_ALL_WATER_QUALITY = "GET_ALL_WATER_QUALITY";
export const GET_WATER_QUALITY_BY_ID = "GET_WATER_QUALITY_BY_ID";
export const CREATE_WATER_QUALITY = "CREATE_WATER_QUALITY";
export const UPDATE_WATER_QUALITY = "UPDATE_WATER_QUALITY";
export const DELETE_WATER_QUALITY = "DELETE_WATER_QUALITY";
export const UPLOAD_WATER_QUALITY_DOCUMENT = "UPLOAD_WATER_QUALITY_DOCUMENT";
export const CLEAR_WATER_QUALITY = "CLEAR_WATER_QUALITY";
export const WATER_QUALITY_ERROR = "WATER_QUALITY_ERROR";

// ReferralLedger types
export const GET_ALL_REFERRAL_LEDGER_REQUEST = "GET_ALL_REFERRAL_LEDGER_REQUEST";
export const GET_ALL_REFERRAL_LEDGER_SUCCESS = "GET_ALL_REFERRAL_LEDGER_SUCCESS";
export const GET_REFERRAL_LEDGER_SUCCESS = "GET_REFERRAL_LEDGER_SUCCESS";
export const GET_REFERRAL_LEDGER_STATS_SUCCESS = "GET_REFERRAL_LEDGER_STATS_SUCCESS";
export const GET_USER_REFERRALS_SUCCESS = "GET_USER_REFERRALS_SUCCESS";
export const GET_USER_REFERRED_BY_SUCCESS = "GET_USER_REFERRED_BY_SUCCESS";
export const CREATE_REFERRAL_LEDGER_SUCCESS = "CREATE_REFERRAL_LEDGER_SUCCESS";
export const UPDATE_REFERRAL_LEDGER_SUCCESS = "UPDATE_REFERRAL_LEDGER_SUCCESS";
export const DELETE_REFERRAL_LEDGER_SUCCESS = "DELETE_REFERRAL_LEDGER_SUCCESS";
export const COMPLETE_REFERRAL_SUCCESS = "COMPLETE_REFERRAL_SUCCESS";
export const CANCEL_REFERRAL_SUCCESS = "CANCEL_REFERRAL_SUCCESS";
export const REFERRAL_LEDGER_ERROR = "REFERRAL_LEDGER_ERROR";
export const REFERRAL_LEDGER_LOADING = "REFERRAL_LEDGER_LOADING";

// Dashboard types
export const GET_DASHBOARD_STATS = "GET_DASHBOARD_STATS";
export const GET_DASHBOARD_DETAILED_STATS = "GET_DASHBOARD_DETAILED_STATS";
export const DASHBOARD_ERROR = "DASHBOARD_ERROR";
export const DASHBOARD_LOADING = "DASHBOARD_LOADING";

// User Activity Reports types
export const GET_USER_ACTIVITY_REPORT = "GET_USER_ACTIVITY_REPORT";
export const GET_USER_ANALYTICS_REPORT = "GET_USER_ANALYTICS_REPORT";
export const GET_USER_SUMMARY_REPORT = "GET_USER_SUMMARY_REPORT";
export const USER_ACTIVITY_REPORT_LOADING = "USER_ACTIVITY_REPORT_LOADING";
export const USER_ACTIVITY_REPORT_ERROR = "USER_ACTIVITY_REPORT_ERROR";

// Refund types
export const CREATE_REFUND_SUCCESS = "CREATE_REFUND_SUCCESS";
export const CREATE_REFUND_ERROR = "CREATE_REFUND_ERROR";
export const GET_REFUND_SUCCESS = "GET_REFUND_SUCCESS";
export const GET_ALL_REFUNDS_SUCCESS = "GET_ALL_REFUNDS_SUCCESS";
export const GET_PAYMENT_REFUNDS_SUCCESS = "GET_PAYMENT_REFUNDS_SUCCESS";
export const REFUND_LOADING = "REFUND_LOADING";
export const REFUND_ERROR = "REFUND_ERROR";
export const CLEAR_REFUND = "CLEAR_REFUND";

// Payment Link types
export const CREATE_PAYMENT_LINK_SUCCESS = "CREATE_PAYMENT_LINK_SUCCESS";
export const CREATE_PAYMENT_LINK_ERROR = "CREATE_PAYMENT_LINK_ERROR";
export const GET_ALL_PAYMENT_LINKS_SUCCESS = "GET_ALL_PAYMENT_LINKS_SUCCESS";
export const GET_ALL_PAYMENT_LINKS_ERROR = "GET_ALL_PAYMENT_LINKS_ERROR";
export const GET_PAYMENT_LINK_BY_ID_SUCCESS = "GET_PAYMENT_LINK_BY_ID_SUCCESS";
export const GET_PAYMENT_LINK_BY_ID_ERROR = "GET_PAYMENT_LINK_BY_ID_ERROR";
export const VERIFY_PAYMENT_LINK_STATUS_SUCCESS = "VERIFY_PAYMENT_LINK_STATUS_SUCCESS";
export const VERIFY_PAYMENT_LINK_STATUS_ERROR = "VERIFY_PAYMENT_LINK_STATUS_ERROR";
export const PAYMENT_LINK_LOADING = "PAYMENT_LINK_LOADING";
export const CLEAR_PAYMENT_LINK = "CLEAR_PAYMENT_LINK";

// WhatsApp analytics types
export const WA_LOADING = "WA_LOADING";
export const WA_ERROR = "WA_ERROR";
export const GET_WA_OVERVIEW = "GET_WA_OVERVIEW";
export const GET_WA_JOURNEYS = "GET_WA_JOURNEYS";
export const GET_WA_MESSAGES = "GET_WA_MESSAGES";
export const GET_WA_OFFERS = "GET_WA_OFFERS";
export const GET_WA_OFFERS_LIST = "GET_WA_OFFERS_LIST";
export const GET_WA_SUPPORT = "GET_WA_SUPPORT";
export const GET_WA_SUPPORT_STATS = "GET_WA_SUPPORT_STATS";
export const GET_WA_REASONS = "GET_WA_REASONS";
export const GET_WA_TIMELINE = "GET_WA_TIMELINE";